import setCookie from './set-cookie';

export default function deleteCookie(name: string): void {
    setCookie(name, '', -1);
}
